import React from "react";
import SubAllowableContent from "./SubAllowableContent";

function AllowableContent () {
    return(
        <div className="container">
            <div className="row EmpContentSec">
                <div className="col-12">
                    <SubAllowableContent />
                </div>
            </div>
            <div className="row EmpContentSec">
                <div className="col-12">
                    <SubAllowableContent />
                </div>
            </div>
            <div className="row EmpContentSec">
                <div className="col-12">
                    <SubAllowableContent />
                </div>
            </div>
        </div>
    )
}

export default AllowableContent ;